import React from 'react';
import styles from './styles.sass';

export default function PageHeader({ className = '', title, children }) {
  return (
    <div className={`${styles.pageHeader} ${className}`}>
      {title && <h1>{title}</h1>}

      <div className={styles.content}>{children}</div>
    </div>
  );
}
